import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';

const TourPackageDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { route } = location?.state || {};
  const [selectedDay, setSelectedDay] = useState('2');
  const [selectedCar, setSelectedCar] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!route) {
      navigate('/homepage');
    }
  }, [route, navigate]);

  const days = ['2', '3', '4', '5', '6', '7', '8'];

  const carTypes = [
  {
    id: 1,
    name: 'Maruti Dzire',
    luggage: 3,
    seats: 4,
    price: 9000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    alt: 'White Maruti Dzire sedan car with sleek design parked on city street'
  },
  {
    id: 2,
    name: 'Toyota Etios',
    luggage: 3,
    seats: 4,
    price: 9900,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fa4f3bb6-1768370735711.png",
    alt: 'Toyota Etios sedan car in white color with modern design'
  },
  {
    id: 3,
    name: 'Brezza',
    luggage: 4,
    seats: 4,
    price: 10800,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    alt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    id: 4,
    name: 'Maruti Ertiga',
    luggage: 4,
    seats: 6,
    price: 11700,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png",
    alt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
  },
  {
    id: 5,
    name: 'Innova Crysta',
    luggage: 6,
    seats: 6,
    price: 15300,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    alt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
  },
  {
    id: 6,
    name: 'Innova Hycross',
    luggage: 5,
    seats: 6,
    price: 18900,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png',
    alt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
  },
  {
    id: 7,
    name: 'Tempo Traveller',
    luggage: 8,
    seats: 12,
    price: 25200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
    alt: 'White tempo traveller minibus parked at tourist destination with group of travelers standing nearby'
  },
  {
    id: 8,
    name: 'Tempo Traveller',
    luggage: 15,
    seats: 17,
    price: 27000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
    alt: 'Large tempo traveller for group travel with spacious seating'
  },
  {
    id: 9,
    name: 'Force Urbania',
    luggage: 16,
    seats: 16,
    price: 34200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
    alt: 'Force Urbania luxury van with premium interiors for group travel'
  },
  {
    id: 10,
    name: 'Tempo Traveller',
    luggage: 15,
    seats: 25,
    price: 34200,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1aa88d0b3-1766989338775.png',
    alt: 'Extra large tempo traveller for large group travel'
  }];


  const additionalPackages = [
  { destination: 'Chandigarh To Amarnath', price: '₹ 18000/-' },
  { destination: 'Chandigarh To Dharamshala', price: '₹ 7000/-' },
  { destination: 'Chandigarh To Shimla', price: '₹ 5500/-' },
  { destination: 'Chandigarh To Mussoorie', price: '₹ 7000/-' },
  { destination: 'Chandigarh To Nainital', price: '₹ 13200/-' },
  { destination: 'Chandigarh To Manali', price: '₹ 7500/-' },
  { destination: 'Chandigarh To Himachal Pradesh', price: '₹ 7000/-' },
  { destination: 'Chandigarh To Amritsar', price: '₹ 7000/-' },
  { destination: 'Chandigarh To Golden Temple Amritsar', price: '₹ 7000/-' },
  { destination: 'Chandigarh To Delhi Airport', price: '₹ 6000/-' },
  { destination: 'Chandigarh To Delhi', price: '₹ 6000/-' }];


  const handleSelectCar = (car) => {
    setSelectedCar(car?.id);
    navigate('/car-details', {
      state: {
        route,
        vehicle: car
      }
    });
  };

  const handlePackageClick = (pkg) => {
    const [from, to] = pkg?.destination?.split(' To ');
    navigate('/tour-package-details', {
      state: {
        route: {
          from: from,
          to: to
        }
      }
    });
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-16 lg:pt-20">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center">
              {route?.from} to {route?.to} Taxi Tour packages
            </h1>
            <p className="text-center text-white/90 mt-4 text-lg">Advait Tour and Travels</p>
          </div>
        </div>

        {/* Day Selection Tabs */}
        <div className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-wrap gap-2 justify-center">
              {days?.map((day) =>
              <button
                key={day}
                onClick={() => setSelectedDay(day)}
                className={`px-6 md:px-12 py-3 rounded-full font-semibold text-sm md:text-base transition-all duration-200 ${
                selectedDay === day ?
                'bg-yellow-400 text-gray-900 shadow-md' :
                'bg-white text-gray-700 border border-gray-300 hover:border-yellow-400'}`
                }>

                  {day} DAYS
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Car Selection Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          <div className="space-y-6">
            {carTypes?.map((car) =>
            <div
              key={car?.id}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden">

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 p-4 md:p-6 items-center">
                  {/* Car Image */}
                  <div className="md:col-span-2">
                    <div className="w-full h-24 md:h-28 flex items-center justify-center">
                      <Image
                      src={car?.image}
                      alt={car?.alt}
                      className="w-full h-full object-contain" />

                    </div>
                  </div>

                  {/* Car Details */}
                  <div className="md:col-span-3">
                    <p className="text-xs text-gray-500 uppercase mb-1">Car Type</p>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900">{car?.name}</h3>
                    <button className="text-sm text-green-600 font-medium mt-1 hover:underline">
                      More Details
                    </button>
                  </div>

                  {/* Luggage */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Briefcase" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{car?.luggage} Luggage</p>
                    </div>
                  </div>

                  {/* Seats */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Users" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{car?.seats} Seats</p>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="md:col-span-2 text-center md:text-right">
                    <p className="text-2xl md:text-3xl font-bold text-green-600">
                      ₹{car?.price?.toLocaleString('en-IN')}/-
                    </p>
                    <p className="text-xs text-gray-500">Inc. of Taxes*</p>
                  </div>

                  {/* Select Button */}
                  <div className="md:col-span-1">
                    <button
                    onClick={() => handleSelectCar(car)}
                    className="w-full px-4 py-2.5 bg-yellow-400 hover:bg-yellow-500 text-gray-900 rounded-lg font-bold text-sm transition-all duration-200">

                      Select Car
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Taxi Tour Packages From Chandigarh */}
        <div className="bg-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-orange-500 mb-6 text-center">
              Taxi Tour Packages From {route?.from}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {additionalPackages?.map((pkg, index) =>
              <div
                key={index}
                onClick={() => handlePackageClick(pkg)}
                className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-lg p-4 hover:shadow-lg transition-all duration-300 cursor-pointer hover:scale-105">

                  <h3 className="text-sm md:text-base font-semibold text-gray-800 mb-2">
                    {pkg?.destination}
                  </h3>
                  <p className="text-lg md:text-xl font-bold text-blue-600">{pkg?.price}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Visitor's Guide */}
        <div className="bg-gray-50 py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-orange-500 mb-6">Visitor's Guide</h2>
            
            <div className="bg-white rounded-xl shadow-md p-6 md:p-8 space-y-6">
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Experience the Scenic {route?.from} to {route?.to} Journey with Advait Tour and Travels
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Introducing Advait Tour and Travels, your reliable travel companion for amazing trips between {route?.from} and {route?.to}. {route?.to}, a popular vacation spot in Himachal Pradesh, is tucked away in the lovely hills and is well-known for its amazing scenery, exciting activities, and calm atmosphere. We at Advait Tour and Travels want to make your journey from {route?.from} to {route?.to} an amazing experience since we recognise the fascination of this breathtaking location.
                </p>
              </div>

              <div>
                <p className="text-gray-700 leading-relaxed">
                  We provide a range of alternatives in our {route?.from} to {route?.to} tour packages to accommodate every traveler's budget and tastes. Our packages are suitable for both short-term and long-term travel needs. Each of our packages is created to guarantee that you enjoy the time of your life amid the breathtaking Himalayan scenery.
                </p>
              </div>

              <div>
                <p className="text-gray-700 leading-relaxed">
                  Your comfort, security, and happiness are our top priorities at Advait Tour and Travels. A pleasant and easy ride is guaranteed by our fleet of well-maintained cars and our kind and competent drivers. We are the go-to option for tourists looking for a hassle-free trip because of our flexible schedule, which also enables you to travel whenever it suits you.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Highlight of Advait Tour and Travels Services
                </h3>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Car" size={20} className="text-blue-600" />
                      1. Comfortable Vehicles
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      We know how important it is to travel comfortably, particularly if it's a long trip. For this reason, we keep a fleet of pristine, well-equipped cars to meet your demands. Our vehicles are roomy, spotless, and furnished with contemporary conveniences to guarantee a relaxing journey for you and your fellow passengers. Whether you're going alone, with family, or in a group, we have the ideal car to meet your requirements.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Clock" size={20} className="text-blue-600" />
                      2. Flexible Scheduling
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      We are aware that every traveller has different tastes and timetables. We provide various scheduling choices in order to meet your needs. Our staff will collaborate with you to schedule a departure time that works for you, whether you would rather travel during the day or at night. We also allow you to start and finish your journey at your favourite locations because we are flexible with pick-up and drop-off locations.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Settings" size={20} className="text-blue-600" />
                      3. Tailored Packages
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      We are committed to giving you experiences that are specifically catered to your interests. You can alter our tour packages from {route?.from} to {route?.to} to suit your needs and budget by adding or removing services. We can create a package that fits your needs, whether you want to incorporate things like sightseeing, adventure sports, or cultural events. Ensuring you have the most rewarding and pleasurable journey possible is our main objective.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="IndianRupee" size={20} className="text-blue-600" />
                      4. Transparent Pricing
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      At Advait Tour and Travels, we value openness and truthfulness in our pricing. The cost of our {route?.from} to {route?.to} trip package is stated up front; there are no additional costs or surprises. For each of our services, we offer thorough pricing breakdowns so you can be sure you're getting what you paid for. You can travel with confidence when you work with us since there are no hidden fees and you're receiving excellent value for your money.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Explore {route?.from} with Our Taxi Tour Package from {route?.to}
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You may easily visit the bustling city of {route?.from} with our hassle-free cab trip package from {route?.to} to {route?.from}, provided by Advait Tour and Travels. Our {route?.from} taxi tour package from {route?.to} is made to ensure that your trip is memorable and pleasurable. What to anticipate from our bundle is as follows:
                </p>

                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Route" size={20} className="text-blue-600" />
                      1. Flexible Itinerary
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      With our customisable schedule, {route?.from} tour package from {route?.to} by car lets you see the city at your own speed. Our drivers will make accommodations for your preferences, whether you wish to see the famous Rock Garden, take a leisurely stroll through the lovely Rose Garden, or marvel at the Capitol Complex's architectural design.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Navigation" size={20} className="text-blue-600" />
                      2. Convenient Transportation
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      Bid farewell to the inconveniences of taking public transit or self-driving. With our taxi tour package, you can unwind and take in the beautiful scenery as our knowledgeable drivers transport you in a cosy vehicle from {route?.to} to {route?.from}.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Armchair" size={20} className="text-blue-600" />
                      3. Convenient Trip Experience
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      Enjoy a comfortable ride in one of our well-kept cars with all the latest conveniences. Our well-maintained and roomy automobiles provide you a comfortable and stress-free ride. Regardless of your travel preferences—solo, family, or group—we have the ideal car for you.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="UserCheck" size={20} className="text-blue-600" />
                      4. Professional Advice
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      Our drivers can provide you insights about {route?.from}'s history, culture, and tourist spots in addition to serving as your chauffeur. Please do not hesitate to ask them for advice or details on the locations you visit.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Why Choose Advait Tour and Travels for Tour Packages
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Star" size={20} className="text-blue-600" />
                      1. Exceptional Customer Satisfaction
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      Customer satisfaction is our first goal at Advait Tour and Travels. To make sure that every part of your vacation surpasses your expectations, we go above and beyond. Our passionate staff is committed to giving you the best possible service and assistance from the time you reserve your tour package until the end of your trip.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="DollarSign" size={20} className="text-blue-600" />
                      2. Reasonable priced rates with no additional fees
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      We think that everyone ought to be able to enjoy the benefits of travel without having to break the wallet. Because of this, we provide trip packages at cost-effective prices that don't include any unexpected costs or extras. You may take pleasure in a stress-free holiday with Advait Tour and Travels without having to worry about unforeseen expenses.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Map" size={20} className="text-blue-600" />
                      3. Wide Range of Destinations and Packages
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      Advait Tour and Travels provides a range of {route?.from} to {route?.to} packages to fit your interests, including leisurely beach vacations, thrilling mountain hikes, and cultural immersions in vibrant cities. We provide a large selection of locations and adaptable packages to meet the requirements and interests of each and every traveller.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="Headphones" size={20} className="text-blue-600" />
                      4. Professional Advice and Support
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      Our staff of knowledgeable travel advisors is available to assist you at every turn. We are committed to making sure your vacation is everything you have always wanted and more, from assisting you in selecting the ideal location to offering insider advice and suggestions.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                      <Icon name="CheckCircle" size={20} className="text-blue-600" />
                      5. Easy Booking Procedure
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      With Advait Tour and Travels, booking a travel package is simple, quick, and hassle-free. With just a few clicks, you can easily reserve your space and finalise your travel arrangements thanks to our user-friendly website and effective booking system.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-blue-50 to-orange-50 rounded-lg p-6 border-l-4 border-blue-600">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                  Call Now to Reserve Your {route?.from} to {route?.to} Tour Package
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  All set to go from {route?.from} to {route?.to}? With Advait Tour and Travels, reserve your {route?.from} to {route?.to} tour package by road right away. To secure your place, just get in touch with us. Be ready for an amazing trip across breathtaking scenery.
                </p>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={() => window.open('tel:+917998666660', '_self')}
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-all duration-200 flex items-center gap-2">

                    <Icon name="Phone" size={20} />
                    Call Now
                  </button>
                  <button
                    onClick={() => window.open('https://wa.me/917998666660', '_blank')}
                    className="px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 whatsapp-pulse">

                    <Icon name="MessageCircle" size={20} />
                    WhatsApp
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>);

};

export default TourPackageDetails;